import * as React from 'react'
import { Document, Page } from 'react-pdf'

import { Spinner } from '@/components/ui'

type TPDFViewerProps = {
  signedUrl: string
  currentPage: number
  scale: number
  pdfError: Error | null
  onDocumentLoadSuccess: (params: { numPages: number }) => void
  onDocumentLoadError: (error: Error) => void
  onPageRenderSuccess: () => void
}

const PDFViewer: React.FC<TPDFViewerProps> = ({
  signedUrl,
  currentPage,
  scale,
  pdfError,
  onDocumentLoadSuccess,
  onDocumentLoadError,
  onPageRenderSuccess,
}) => {
  if (pdfError) {
    return (
      <div className="flex items-center justify-center p-8">
        <div className="text-center">
          <p className="text-secondary-700 mb-2">
            {pdfError.message || 'Failed to load PDF document'}
          </p>
        </div>
      </div>
    )
  }

  return (
    <Document
      key={signedUrl}
      file={signedUrl}
      onLoadSuccess={onDocumentLoadSuccess}
      onLoadError={onDocumentLoadError}
      loading={
        <div className="flex items-center justify-center p-8">
          <Spinner />
        </div>
      }
    >
      <Page
        pageNumber={currentPage}
        scale={scale}
        renderTextLayer={false}
        renderAnnotationLayer={false}
        onRenderSuccess={onPageRenderSuccess}
        loading={
          <div className="flex items-center justify-center p-8">
            <Spinner />
          </div>
        }
      />
    </Document>
  )
}

const PDFViewerMemoized = React.memo(PDFViewer)
PDFViewerMemoized.displayName = 'PDFViewer'

export { PDFViewerMemoized as PDFViewer }
